import styled from 'styled-components';

import { FormControlLabel } from '@material-ui/core';

import { px } from '../../util/style';
import { colors, din } from '../../styles/variables';

// Control label
interface FormControlLabelProps {
  large?: boolean;
  disabled?: boolean;
}
export const ControlLabel = styled(FormControlLabel)<FormControlLabelProps>`
  margin: 0;

  & .MuiFormControlLabel-label {
    color: ${colors.gray87};
    font-family: ${din};
    font-size: ${px(16)};
    margin-right: ${px(4)};

    ${props =>
      props.large &&
      `
      font-size: ${px(18)};
    `}
  }

  ${props =>
    props.disabled &&
    `
    & .label {
      color: ${colors.gray87};
    }
  `}
`;
